<div class="row">
    <div class="col-md-12 col-lg-12">
        <div class="card">
            <div class="card-body">
                <button class="btn btn-primary float-right" (click)="createClient()">Create client</button>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-12">
        <div class="card">
            <div class="card-body">
                <spinner [showSpinner]="isLoading">
                    <div class="table-container">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th class="col-max-60"></th>
                                        <th class="col-max-20"></th>
                                        <th class="col-max-60"></th>
                                        <th class="col-max-20" (click)="orderBy('clientType')"></th>
                                        <th (click)="orderBy('clientId')">Id</th>
                                        <th class="col-max-200" (click)="orderBy('clientName')">Name</th>
                                        <th (click)="orderBy('createdAt')">Created</th>
                                        <th (click)="orderBy('lastAccessed')">Last Accessed</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr [ngClass]="{'strike': client.isDeleted}" *ngFor="let client of clients">
                                        <td>
                                            <button class="btn btn-primary btn-sm"
                                                *ngIf = "!client.isDeleted"
                                                (click)="gotoClientSecrets(client)">View</button>
                                        </td>
                                        <td>
                                            <i *ngIf="client.clientId != 'mcd-authadmin' && !client.isDeleted"
                                                confirm
                                                (confirm-action)="toggleEnable(client)"
                                                confirm-message="Do you want to {{ client.enabled ? 'disable' : 'enable'}} {{client.clientId}}?"
                                                class="mdi mdi-record mdi-clickable"
                                                [ngClass]="client.isBusy ? 'notice-gray' : (client.enabled ? 'notice-green' : 'notice-red')"></i>
                                        </td>
                                        <td>
                                            <button class="btn btn-danger btn-sm" [disabled]="client.isBusy" confirm
                                                (confirm-action)="deleteClient(client)"
                                                confirm-message="Do you want to delete client {{client.clientId}}?"
                                                *ngIf="!client.enabled && !client.isDeleted">Delete</button>
                                        </td>
                                        <td>
                                            <i [ngClass]="icon(client)"></i>
                                        </td>
                                        <td>
                                            {{client.clientId}}
                                        </td>
                                        <td>
                                            {{client.clientName}}
                                        </td>
                                        <td>
                                            {{client.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}
                                        </td>
                                        <td>
                                            {{(client.lastAccessed | date:'yyyy-MM-dd HH:mm:ss') || '-'}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </spinner>
            </div>
        </div>
    </div>
</div>